import { z } from 'zod';
import { optionnel, DATE_ISO } from '@shared/validation/helpers';

const types = [
  'annuel',
  'maternite',
  'paternite',
  'maladie',
  'evenement_familial',
  'sans_solde',
  'autre',
] as const;

const statutsInitiaux = ['demande', 'valide', 'refuse'] as const;

export const CongeDemandeSchema = z
  .object({
    salarie_id: z.string().min(1, 'Salarié requis'),
    type: z.enum(types, { error: 'Type de congé requis' }),
    statut: z.enum(statutsInitiaux).default('demande'),
    date_debut: z.string().regex(DATE_ISO, 'Date de début YYYY-MM-DD requise'),
    date_fin: z.string().regex(DATE_ISO, 'Date de fin YYYY-MM-DD requise'),
    motif: optionnel(z.string().max(500)),
  })
  .superRefine((data, ctx) => {
    if (data.date_fin < data.date_debut) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['date_fin'],
        message: 'La date de fin précède la date de début',
      });
    }
    const debut = Date.parse(`${data.date_debut}T00:00:00`);
    const fin = Date.parse(`${data.date_fin}T00:00:00`);
    if (Number.isFinite(debut) && Number.isFinite(fin) && fin - debut > 365 * 86400000) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['date_fin'],
        message: 'La durée ne peut pas dépasser 365 jours',
      });
    }
  });

export type CongeDemandeInput = z.infer<typeof CongeDemandeSchema>;
